const BORROWER_ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const BORROWER_RESERVED_SEGMENTS = new Set(["credit-history", "guarantors", "collateral"]);

export function isBorrowerId(value) {
  return BORROWER_ID_RE.test(String(value || ""));
}

export function isBorrowerListLayout(segment) {
  return Boolean(segment) && !isBorrowerId(segment) && !BORROWER_RESERVED_SEGMENTS.has(segment);
}

export function borrowerProfilePath(pub = "", borrowerId) {
  return `${pub}/credora/borrowers/${borrowerId}`;
}

export function borrowersListPath(pub = "", layoutURL) {
  return `${pub}/credora/borrowers/${layoutURL}`;
}

export function creditHistoryPath(pub = "", layoutURL) {
  return `${pub}/credora/borrowers/credit-history/${layoutURL}`;
}

export function guarantorsPath(pub = "", layoutURL) {
  return `${pub}/credora/borrowers/guarantors/${layoutURL}`;
}

export function collateralPath(pub = "", layoutURL) {
  return `${pub}/credora/borrowers/collateral/${layoutURL}`;
}
